import React, { Suspense } from "react";
import { Styles } from "../../ui/track/TrackingPage/TrackingPage.style";

const FooterQship = React.lazy(() => import("ui/Footer"));

function Footer({
  backgroundColor,
  className,
  isFullWidth,
}: {
  backgroundColor?: string;
  className?: any;
  isFullWidth?: boolean;
}) {
  const classes = Styles();

  return (
    <Suspense fallback="">
      <FooterQship
        backgroundColor={backgroundColor}
        className={[className, isFullWidth ? "w-full" : "", classes.footer].join(" ")}
      />
    </Suspense>
  );
}

export default Footer;
